import React from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import TrustLedgerModal from "./TrustLedgerModal";
import AttachmentModal from "./AttachmentModal";
import {
  JournalCheck,
  Paperclip,
  CreditCard,
  ArrowRepeat,
} from "react-bootstrap-icons";
import { ComingSoonWrapper } from "../BorrowerDashboardTwo/Payments";
import { useDispatch, useSelector } from "react-redux";
import { setManualSelectedAccount } from "../../../store/reducers/accountSlice";
function QuickActionsCard({ accountType }) {
  const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);
  const accountId = useSelector((state) => state.account.lenderId);
  const selectedAccount = useSelector((state) => state.account.selectedAccount);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [attach, setAttach] = useState(false);

  function handleAutoPay() {
    navigate("/ach-payment", {
      state: {
        accountId: accountId,
        single: true,
      },
    });
  }

  return (
    <Card
      style={
        isLargeDevice
          ? { border: "1px solid #ddd", marginLeft: "5px" }
          : { border: "1px solid #ddd", marginLeft: "5px" }
      }
      className=" border border-primary p-0"
    >
      <Card.Body className="d-flex flex-column p-0 gap-2">
        <Card.Header style={{ fontWeight: "bold" }}>Quick Actions</Card.Header>
        {accountType === "Active" ? (
          <Row className="flex-fill">
            <Col className="d-flex">
              <ComingSoonWrapper
                label={"Same Day Payment"}
                tooltip={"Same Day Payment"}
              >
                <Button
                  variant="light"
                  className="d-flex justify-content-center align-items-center w-100 mt-4 ms-4 flex-fill border hover-effect-actions"
                  style={{
                    // height: "6rem",
                    border: "1px solid #ddd",
                    backgroundColor: "#f8f9fa",
                  }}
                   onClick={() => {
                  navigate("/same-day-payment");
                  dispatch(setManualSelectedAccount(selectedAccount));
                }}
                >
                  <div>
                    <div className="mb-2" style={{ fontSize: "2rem" }}>
                      <CreditCard size={24} color="var(--primary-color)" />
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "var(--primary-color)",
                        fontWeight: "bold",
                      }}
                    >
                      Same Day Payment
                    </div>
                  </div>
                </Button>
              </ComingSoonWrapper>
            </Col>

            <Col className="d-flex">
              <ComingSoonWrapper
                label={"One Time Payment"}
                tooltip={"One Time Payment"}
              >
                <Button
                  variant="light"
                  className="d-flex justify-content-center align-items-center w-100 mt-4 flex-fill border hover-effect-actions"
                  style={{
                    // height: "6rem",
                    border: "1px solid #ddd",
                    backgroundColor: "#f8f9fa",
                  }}
                  onClick={() => {
                  navigate("/one-time-payment");
                  dispatch(setManualSelectedAccount(selectedAccount));
                }}
                >
                  <div>
                    <div className="mb-2" style={{ fontSize: "2rem" }}>
                      <CreditCard size={24} color="var(--primary-color)" />
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "var(--primary-color)",
                        fontWeight: "bold",
                      }}
                    >
                      One Time Payment
                    </div>
                  </div>
                </Button>
              </ComingSoonWrapper>
            </Col>

            <Col className="d-flex">
              <ComingSoonWrapper
                label={"Setup Autopay"}
                tooltip={"Setup Autopay"}
              >
                <Button
                  variant="light"
                  className="d-flex justify-content-center align-items-center w-100 mt-4 me-4 flex-fill border hover-effect-actions"
                  style={{
                    // height: "6rem",
                    border: "1px solid #ddd",
                    backgroundColor: "#f8f9fa",
                  }}
                  onClick={() => handleAutoPay()}
                >
                  <div>
                    <div className="mb-2" style={{ fontSize: "2rem" }}>
                      <ArrowRepeat size={24} color="var(--primary-color)" />
                    </div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "var(--primary-color)",
                        fontWeight: "bold",
                      }}
                    >
                      Setup Autopay
                    </div>
                  </div>
                </Button>
              </ComingSoonWrapper>
            </Col>
          </Row>
        ) : null}
        <Row className="flex-fill">
          <Col className="d-flex">
            <ComingSoonWrapper
              label={"View Trust Ledger"}
              tooltip={"View Trust Ledger"}
            >
              <Button
                variant="light"
                className="d-flex justify-content-center align-items-center w-100 ms-4 my-4 flex-fill border hover-effect-actions"
                style={{
                  // height: "6rem",
                  border: "1px solid #ddd",
                  backgroundColor: "#f8f9fa",
                }}
                onClick={() => setShow(true)}
              >
                <div>
                  <div className="mb-2" style={{ fontSize: "2rem" }}>
                    <JournalCheck size={24} color="var(--primary-color)" />
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "var(--primary-color)",
                      fontWeight: "bold",
                    }}
                  >
                    View Trust Ledger
                  </div>
                </div>
              </Button>
            </ComingSoonWrapper>
          </Col>
          <Col className="d-flex">
            <ComingSoonWrapper
              label={"View Attachments"}
              tooltip={"View Attachments"}
            >
              <Button
                variant="light"
                className="d-flex justify-content-center align-items-center w-100 mt-4 mb-4 me-4 flex-fill border hover-effect-actions"
                style={{
                  // height: "6rem",
                  border: "1px solid #ddd",
                  backgroundColor: "#f8f9fa",
                }}
                onClick={() => setAttach(true)}
              >
                <div>
                  <div className="mb-2" style={{ fontSize: "2rem" }}>
                    <Paperclip size={24} color="var(--primary-color)" />
                  </div>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "var(--primary-color)",
                      fontWeight: "bold",
                    }}
                  >
                    View Attachments
                  </div>
                </div>
              </Button>
            </ComingSoonWrapper>

            <TrustLedgerModal show={show} setShow={setShow} />
            <AttachmentModal attach={attach} setAttach={setAttach} />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default QuickActionsCard;
